import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { IncomingInvoiceDeliveryNoteListItem } from "@msuite/utils/types";

/** Props Interface */
interface DeliveryNoteInvoiceCellProps {
	invoice: IncomingInvoiceDeliveryNoteListItem["invoice"];
}

/** The invoice that bills a delivery note, or a tag saying it still waits for one. */
export function DeliveryNoteInvoiceCell({ invoice }: DeliveryNoteInvoiceCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (invoice) return <span>{invoice.number ?? "–"}</span>;
	return (
		<Tag
			size="xs"
			color="amber"
			variant="plain"
		>
			{t("incoming_invoices.delivery_notes.waiting")}
		</Tag>
	);
}
